import { useState, useEffect } from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import { useForm, Controller } from 'react-hook-form'

import { fetcher, ContentType, RequestMethod } from "../utils/fetcher"
import ProcessingRing from './common/processing-ring'

type Props = {
  baseUrl: string
  messageBubble2Url: string
  staffEmailUrl: string
  isAuthenticated: boolean
  wantedUrl: string
  errorMessage: string
  statusCode: number
}

export default function ErrorComponent({
  baseUrl,
  messageBubble2Url,
  staffEmailUrl,
  isAuthenticated,
  wantedUrl,
  errorMessage,
  statusCode
}: Props): JSX.Element {
  const { handleSubmit, register, control, reset } = useForm()
  const [error, setError] = useState('')
  const [villain, setVillain] = useState<Villain>()
  const [isWantedBoxShown, setWantedBoxShown] = useState(false)
  const [isVillainLabelShown, setVillainLabelShown] = useState(false)
  const [isContactUsShown, setContactUsShown] = useState(false)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    const villains = window.villains

    const selected = Math.max(0, Math.round(Math.random() * villains.length) - 1);
    setVillain(villains[selected])

    setTimeout(() => {
      setWantedBoxShown(true)

      setTimeout(() => {
        setVillainLabelShown(true)
      }, 500)

      setTimeout(() => {
        setContactUsShown(true)
      }, 1000)
    }, 2000)
  }, [])

  const getImageUrl = (base: string, suffix?: string) => {
    let url = baseUrl + base;
    if (suffix) url += "-" + suffix;
    return url + ".png";
  }

  const onSubmit = async (body) => {
    setLoading(true)

    try {
      await fetcher(staffEmailUrl, {
        method: RequestMethod.POST,
        contentType: ContentType.FormUrlEncoded,
        body
      })

      setLoading(false)
      reset()
      alert("Thanks, your message has been received. We'll get back to you as soon as possible")
    }
    catch (error) {
      setError(error.data?.message || error.message)
      setLoading(false)
    }
  }

  if (!villain) {
    return null
  }

  return (
    <div id="villain-image-box" style={{ backgroundImage: `url('${getImageUrl(villain.base)}')` }} className="relative mt-10">
      <div id="villain-text-bubble" style={{ backgroundImage: `url('${messageBubble2Url}')` }}>
        <div id="villain-message-text">
          {villain[statusCode.toString()]}
        </div>
      </div>

      {isContactUsShown ? <div id="contact-us" className="absolute -right-20 top-36 w-80">
        <div className="text-xl font-bold">Having Problems?</div>
        <form id="submit-message-form" className="error-container" onSubmit={handleSubmit(onSubmit)}>
          {error ? <div className='error-message mb-2'>{error}</div> : null}
          <Controller
            name="message"
            control={control}
            defaultValue=''
            render={({ field: { onChange, value } }) => (
              <TextareaAutosize
                value={value}
                onChange={(event) => onChange(event.target.value)}
                className="mt-2"
                id="user-message"
                name="message"
                placeholder="explain the problem you're experiencing"
                minRows={3} />
            )} />
          {!isAuthenticated ?
            <input
              {...register('email')}
              className="mt-2"
              type="text"
              id="email"
              placeholder="what email should we respond to?" />
            : null}
          <input
            {...register('errorMessage')}
            type="hidden"
            value={errorMessage} />
          <input
            {...register('location')}
            type="hidden"
            value={window.location.href} />
          {isLoading
            ? <div className="h-12 mt-4">
              <ProcessingRing isLoading={true} size={10}></ProcessingRing>
            </div>
            : <input
              type="submit"
              value="Tell us what's going wrong"
              name="submit"
              className="button-alert w-full mt-2" />}

        </form>
      </div> : null}

      {isVillainLabelShown ? <div id="villain-label" style={{ backgroundImage: `url('${getImageUrl(villain.base, "label")}')` }}>&nbsp;</div> : null}

      {isWantedBoxShown ? <div id="wanted-box" className="relative" style={{ backgroundImage: `url('${wantedUrl}')` }}>
        <div id="mug-shot" style={{ backgroundImage: `url('${getImageUrl(villain.base, "mug")}')` }}>
          &nbsp;
        </div>
        <div id="wanted-for-message">
          For the Following Crimes:
        </div>
        <ol id="wanted-for-reason">
          {villain.crimes.map((crime, index) => <li key={index}>{crime}</li>)}
        </ol>
      </div> : null}
    </div >
  )
}
